import React from 'react';
import hs from "../assets/hs.png";

const RefHS = () => {
  return (
    <div>
      <div className="p-5 sm:px-20 bg-slate-100 dark:bg-slate-900 dark:text-white m-5 rounded-3xl">
        <h1 className="text-center underline font-serif text-3xl font-bold text-purple-700">
          Higher Secondary (XII)
        </h1>
        <div className="bg-slate-200 dark:bg-slate-700 rounded-2xl my-10 py-5 sm:py-10 px-5">
          <div className="flex justify-center">
            <div>
              <img className="rounded-2xl w-full max-w-[720px] h-auto" src={hs} alt="Higher Secondary marksheet of Subhadip Das" loading="lazy" decoding="async" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RefHS
